import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewChildren,
  ElementRef,
  QueryList,
} from '@angular/core';
@Component({
  selector: 'app-template12',
  templateUrl: './template12.component.html',
  styleUrls: ['./template12.component.scss'],
})
export class Template12Component {
  @Input() data: any;
  @Input() isThumbnail: boolean = false;

  @ViewChild('measureContainer') measureContainer!: ElementRef;
  @ViewChildren('sectionRefs', { read: ElementRef })
  sectionRefs!: QueryList<ElementRef>;

  allSections: any[] = [];
  pages: any[][] = [];

  ngOnInit(): void {}
}
